module.exports = __webpack_public_path__ + "img/ARCH_10_prew.56210eac.jpg";